import { useQuery } from '@tanstack/react-query';
import type { ActivityInsights } from 'clients/app/src/api/activities/insights/insightSchema';

import { getActivityInsights } from '../../../../api/activities/insights/getActivityInsights';
import { queryKey } from '../queryKey';

interface UseGetActivityInsightsParams<T = ActivityInsights> {
  activityInstanceId: number;
  refetchInterval?: number;
  retry?: boolean | number;
  select?: (data: ActivityInsights) => T;
}

export function useGetActivityInsights<T = ActivityInsights>({
  activityInstanceId,
  refetchInterval,
  retry,
  select,
}: UseGetActivityInsightsParams<T>) {
  return useQuery({
    select,
    queryKey: queryKey.insightsById(activityInstanceId),
    queryFn: () => getActivityInsights(activityInstanceId),
    retry: retry,
    refetchInterval,
  });
}
